import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Link/LinkUsage.mdx";

import Examples from "../../Docs/Components/Link/LinkExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Link"
            description="Links are used to navigate between pages."
            apiSources={["azure-devops-ui/Components/Link/Link.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;